import { useQueryParams } from '@/hooks';
import { useRequestGetPromoCodes } from '@/hooks/httpRequest/promoCodes';
import { DataTablePageSizeEnum, PromoCodeStatusEnum } from '@/enums';

/* The list of offers with its page and status filter, kept in the URL */
const usePromoCodes = () => {
	const {
		updateSearchParams,
		urlSearchParams,
		values: [page, limit],
	} = useQueryParams(['page', 'limit', 'status'], { page: 1, limit: DataTablePageSizeEnum._15 });
	const status = urlSearchParams.getAll('status') as PromoCodeStatusEnum[];

	const { offers, data, isLoading } = useRequestGetPromoCodes({
		status: status.length ? status : undefined,
		page,
		limit,
	});

	const handleStatusChange = (values: string[]) =>
		updateSearchParams(prev => {
			prev.delete('status');
			values.forEach(value => prev.append('status', value));
			return prev;
		});

	return { offers, isLoading, status, pageCount: data?.pagination?.pageCount, handleStatusChange };
};

export default usePromoCodes;
